import { render } from "./registrationPopup.vue?vue&type=template&id=0b0ab6db"
import script from "./registrationPopup.vue?vue&type=script&lang=js"
export * from "./registrationPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__